import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Behaviordriving from './Index'
import Preview from './Previewtable'

export default () => (
  <Switch>
    <Route exact path="/report/behaviordriving" component={Behaviordriving} />
    <Route exact path="/report/behaviordriving/preview" component={Preview} />
  </Switch>
)
